import React, { useState } from 'react';
import MovingText from '../MovingTexts/MovingTexts';
import { Modal } from '../Modal';
import seedsDonationImage from '../../assets/images/Seeds Donation.png';

const NewsSection = () => {
  const [isDonationImageOpen, setIsDonationImageOpen] = useState(false);

  const newsItems = [
    <div className='relative z-10' key='library'>
      ⁠On-campus exposure visit for awareness about SEEDS activities -{' '}
      <span className='font-bold underline'>5th to 8th October, Duttalur</span>
    </div>,
    <div className='relative z-10' key='library'>
      ⁠Eye awareness program at ZPHS school -{' '}
      <span className='font-bold underline'>9th October, Duttalur</span>
    </div>,
    <div className='relative z-10' key='library'>
      ⁠⁠ATM model implementation demo as part of CRA -{' '}
      <span className='font-bold underline'>20th October, Duttalur</span>
    </div>,
    // <div className='relative z-10' key='assam-donation'>
    //   Donation drive for Assam flood affected families -{' '}
    //   <button
    //     type='button'
    //     className='font-bold underline cursor-pointer'
    //     onClick={() => setIsDonationImageOpen(true)}
    //   >
    //     Click To Know More
    //   </button>
    // </div>,
  ];

  return (
    <div className='w-full overflow-hidden'>
      {newsItems.length > 0 && (
        <div className='flex w-full overflow-hidden text-center justify-center items-center bg-[#0c412f]'>
          <div className='min-w-0 flex-1 overflow-hidden'>
            <MovingText newsItems={newsItems} />
          </div>
        </div>
      )}

      <Modal
        isOpen={isDonationImageOpen}
        onClose={() => setIsDonationImageOpen(false)}
        className='max-w-4xl bg-transparent shadow-none'
      >
        <img
          src={seedsDonationImage}
          alt='Seeds Impact Assam flood donation drive'
          className='w-full h-auto rounded-lg'
        />
      </Modal>
    </div>
  );
};

export default NewsSection;
